import { useEffect, useRef } from 'react'
import { FieldPath, useFormContext, useWatch } from 'react-hook-form'

import { SarEdit } from '~bank-bsa-reporting/types'

const message = 'Item 32-42. At least one type of suspicious activity must be selected'

const fieldNames = [
  'suspiciousActivityInfo.structuring',
  'suspiciousActivityInfo.terroristFinancing',
  'suspiciousActivityInfo.fraud',
  'suspiciousActivityInfo.laundering',
  'suspiciousActivityInfo.identification',
  'suspiciousActivityInfo.otherActivities',
  'suspiciousActivityInfo.gaming',
  'suspiciousActivityInfo.cyber',
  'suspiciousActivityInfo.insurance',
  'suspiciousActivityInfo.mortgage',
  'suspiciousActivityInfo.securities'
]

export const suspiciousActivityInfoValidate = (_, formValues: SarEdit) => {
  const ti = formValues.suspiciousActivityInfo
  if (
    !(
      ti.structuring.length ||
      ti.terroristFinancing.length ||
      ti.fraud.length ||
      ti.laundering.length ||
      ti.identification.length ||
      ti.otherActivities.length ||
      ti.gaming.length ||
      ti.cyber.length ||
      ti.insurance.length ||
      ti.mortgage.length ||
      ti.securities.length
    )
  ) {
    return message
  }

  return undefined
}

export const useSuspiciousActivityInfoValidate = () => {
  const { clearErrors, setError } = useFormContext<SarEdit>()
  const initialRender = useRef(true)

  const fieldValues = useWatch({ name: fieldNames })

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false
      return
    }

    const allEmpty = fieldValues.every((value) => !value || value.length === 0)

    if (allEmpty) {
      fieldNames.forEach((fieldName) => {
        setError(fieldName as FieldPath<SarEdit>, {
          message
        })
      })
    } else {
      clearErrors(fieldNames as [FieldPath<SarEdit>])
    }
  }, [JSON.stringify(fieldValues), setError, clearErrors])
}
